import { Box, Button, Typography, CircularProgress } from "@mui/material";
import DashboardLayout from "components/layouts/DashboardLayout";
import { useLearningRedirect } from "hooks/useLearningRedirect";
import React from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";

const LearningCertificationPage: React.FC = () => {
  const { colors } = useCelleraTheme();
  const { redirectToLearning, isLoading } = useLearningRedirect();

  const handleGoToLearning = async () => {
    await redirectToLearning();
  };

  return (
    <DashboardLayout title="Provider Learning & Certification">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          gap: 3,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            maxWidth: 600,
            px: 3,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              mb: 2,
              color: colors.text.primary,
              fontWeight: 600,
            }}
          >
            Provider Learning & Certification
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: 4,
              color: colors.text.secondary,
              lineHeight: 1.6,
            }}
          >
            Access comprehensive learning resources and certification programs
            designed specifically for healthcare providers. Enhance your
            knowledge and stay up-to-date with the latest practices in patient
            care.
          </Typography>
        </Box>

        <Button
          variant="contained"
          size="large"
          onClick={handleGoToLearning}
          disabled={isLoading}
          sx={{
            minWidth: 200,
            height: 48,
            backgroundColor: colors.primary.main,
            "&:hover": {
              backgroundColor: colors.primary.dark,
            },
            "&:disabled": {
              backgroundColor: colors.primary.main,
            },
          }}
        >
          {isLoading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1, color: "white" }} />
              Loading...
            </>
          ) : (
            "Go to Learning"
          )}
        </Button>
      </Box>
    </DashboardLayout>
  );
};

export default LearningCertificationPage;
